import React from 'react';
import '../App.css';


const aboutSections = [
  {
    img: null,
    text: 'Collecting information and history of the Palnau family.',
    imgLeft: true,
  }
];

export default function Family() {
  return (
    <div className="About-page">
      <div className="About-content">
        {aboutSections.map((section, idx) => (
          <div
            className={`About-section ${section.imgLeft ? 'img-left' : section.imgLeft === null ? '' : 'img-right'}`}
            key={idx}
          >
          {section.img &&
          <img src={section.img} alt="" className="About-img" />
          }
            <p style={{ whiteSpace: 'pre-line', width: '100%' }}>{section.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}